export default {
    'it-IT': {
        moreResults: 'Vedi tutti i prodotti',
        categories: 'categorie',
        brands: 'brand',
        plusOtherBrands: '+ altri {count}',
        plusOtherCategories: '+ altre {count}',
        noResultsFound: 'NON È STATO TROVATO NESSUN RISULTATO.',
    },
    'en-GB': {
        moreResults: 'See all products',
        categories: 'categories',
        brands: 'brands',
        plusOtherBrands: '+ {count} more',
        plusOtherCategories: '+ {count} more',
        noResultsFound: 'NO RESULTS FOUND.',
    },
    'en-US': {
        moreResults: 'See all products',
        categories: 'categories',
        brands: 'brands',
        plusOtherBrands: '+ {count} more',
        plusOtherCategories: '+ {count} more',
        noResultsFound: 'NO RESULTS FOUND.',
    },
    'en-AU': {
        moreResults: 'See all products',
        categories: 'categories',
        brands: 'brands',
        plusOtherBrands: '+ {count} more',
        plusOtherCategories: '+ {count} more',
        noResultsFound: 'NO RESULTS FOUND.',
    },
    'fr-FR': {
        moreResults: 'Voir tous les produits',
        categories: 'Catégories',
        brands: 'Marques',
        plusOtherBrands: '+ {count} plus',
        plusOtherCategories: '+ {count} plus',
        noResultsFound: "AUCUN RÉSULTAT N'A ÉTÉ TROUVÉ.",
    },
    'es-ES': {
        moreResults: 'Ver todos los productos',
        categories: 'Categoría',
        brands: 'Marcas',
        plusOtherBrands: '+ {count} otros',
        plusOtherCategories: '+ {count} otras',
        noResultsFound: 'NO SE HA ENCONTRADO NINGÚN RESULTADO.',
    },
    'de-DE': {
        moreResults: 'Alle Produkte anzeigen',
        categories: 'Kategorien',
        brands: 'Marken',
        plusOtherBrands: '+ {count} weitere',
        plusOtherCategories: '+ {count} weitere',
        noResultsFound: 'KEIN ERGEBNIS GEFUNDEN.',
    },
};
